<backbone>
  <section header-page="topbar" class="d-flex justify-content-between gap-2 h-100 position-relative">
    <div class="d-flex justify-content-start align-items-center text-truncate">
      <p class="m-0 fw-medium text-truncate">Reportes de clientes</p>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-3">
      <breadcrumb [items]="[{ label: 'Reportes' }, { label: 'Reportes de clientes' }]" />
    </div>
  </section>

  <section wrapper>
    <div class="page-section card">
      <div class="card-header border-0 py-1"></div>
      <div class="card-body p-0">
        @if (this.isLoading === false) {
          <p-table
            #dt1
            [value]="report"
            dataKey="id"
            [rows]="25"
            [rowsPerPageOptions]="[25, 50, 100]"
            [paginator]="true"
            paginatorStyleClass="mt-1"
            [globalFilterFields]="['documento', 'estado', 'dato', 'usuario']"
          >
            <ng-template pTemplate="caption">
              <div class="d-flex flex-xl-row gap-2">
                <div class="w-100">
                  <p-inputgroup>
                    <p-iconfield class="w-100">
                      <p-inputicon styleClass="pi pi-search" />
                      <input
                        type="text"
                        pInputText
                        [(ngModel)]="searchValue"
                        (input)="dt1.filterGlobal(searchValue, 'contains')"
                        placeholder="Buscar por documento, estado, dato, usuario."
                        class="w-100 h-50px rounded-end-0"
                      />
                    </p-iconfield>
                    <p-inputgroup-addon *ngIf="searchValue" pTooltip="Limpiar busqueda">
                      <p-button icon="pi pi-times" severity="secondary" class="h-100" styleClass="h-100" (click)="searchValue = ''; dt1.filterGlobal(searchValue, 'contains')" />
                    </p-inputgroup-addon>
                  </p-inputgroup>
                </div>
                <div>
                  <p-iftalabel>
                    <p-select
                      [(ngModel)]="periodSelected"
                      [options]="periodsList"
                      placeholder="Periodo actual"
                      class="w-100 h-50px"
                      appendTo="body"
                      showClear="true"
                      (ngModelChange)="userSelected = null; searchReport()"
                    >
                      <ng-template #selectedItem let-selectedOption>
                        <p class="m-0">{{ selectedOption.period[0] | date: "longDate" }} - {{ selectedOption.period[1] | date: "longDate" }}</p>
                      </ng-template>
                      <ng-template #item let-item>
                        <p class="m-0">{{ item.label }}: {{ item.period[0] | date: "longDate" }} - {{ item.period[1] | date: "longDate" }}</p>
                      </ng-template>
                    </p-select>
                    <label>Perido del reporte</label>
                  </p-iftalabel>
                </div>
                <div class="w-25">
                  <p-iftalabel>
                    <p-select
                      [(ngModel)]="userSelected"
                      [options]="listUsers"
                      placeholder="Mi red"
                      class="w-100 h-50px"
                      appendTo="body"
                      showClear="true"
                      [filter]="true"
                      filterBy="label"
                      optionValue="label"
                      (ngModelChange)="dt1.filterGlobal(userSelected, 'contains'); filterPrice(userSelected)"
                    />
                    <label>Usuario</label>
                  </p-iftalabel>
                </div>
                <!-- <p-button icon="bi bi-search" label="Buscar" severity="secondary" styleClass="h-50px px-3" (click)="searchReport()" /> -->
                <p-button *showForRoles="['SUPERUSER', 'COLABORADOR']" icon="bi bi-cloud-download" label="Reporte" severity="secondary" styleClass="h-50px px-3" (click)="exportToExcel()" />
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th>DOCUMENTO</th>
                <th>FECHA</th>
                <th>ESTADO</th>
                <th>DATO</th>
                <th>USUARIO</th>
                <th *showForRoles="['SUPERUSER', 'COLABORADOR']">PRECIO</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item>
              <tr>
                <td class="text-nowrap small">{{ item.documento }}</td>
                <td class="text-nowrap small">{{ item.fecha | date: "longDate" }}</td>
                <td class="text-nowrap small">{{ item.estado }}</td>
                <td class="text-nowrap small">{{ item.dato }}</td>
                <td class="text-nowrap small">
                  @if (!item.isEditing) {
                    {{ item.usuario }}
                    <p-button icon="bi bi-pencil" styleClass="p-button-text p-button-sm" (click)="item.isEditing = true" *showForRoles="['GESTOR']"></p-button>
                  } @else {
                    <div class="d-flex gap-1 w-100" *showForRoles="['GESTOR']">
                      <p-iftalabel class="w-100">
                        <p-select
                          [(ngModel)]="item.reassign"
                          [options]="listAllUsers"
                          [placeholder]="item.usuario"
                          class="w-100 h-50px"
                          appendTo="body"
                          [filter]="true"
                          filterBy="label"
                          [showClear]="true"
                        />
                        <label>Reasignar a</label>
                      </p-iftalabel>
                      <p-button icon="bi bi-check" styleClass="h-100" severity="success" (click)="reassignUser(item)" />
                      <p-button icon="bi bi-x" styleClass="h-100" severity="danger" (click)="item.isEditing = false; item.reassign = null" />
                    </div>
                  }
                </td>
                <td class="text-nowrap small" *showForRoles="['SUPERUSER', 'COLABORADOR']">{{ item.precio | currency: "MXN" }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="6">No se encontraron registros.</td>
              </tr>
            </ng-template>

            <ng-template #footer>
              <tr *showForRoles="['SUPERUSER', 'COLABORADOR']">
                <td class="text-end" colspan="5">Total</td>
                <td>{{ totalPrice | currency: "MXN" }}</td>
              </tr>
            </ng-template>
          </p-table>
        } @else {
          <placeholder-table [header]="['FECHA', 'ESTADO', 'DATO', 'DOCUMENTO', 'USUARIO', 'PRECIO']" />
        }
      </div>
      <div class="card-footer border-0 py-1"></div>
    </div>

    @if (this.isLoading === false) {
      <div class="page-section card" *showForRoles="['SUPERUSER', 'COLABORADOR']">
        <div class="card-header border-0 py-1"></div>
        <div class="card-body p-0">
          <div class="row row-cols-2 row-cols-md-3 row-cols-lg-5 g-0">
            <div class="col pt-4 pb-4" *showForPermissions="['registro_civil_marco_folio_reverso_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">MARCOS, <br />FOLIOS Y REVERSOS</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.registroCivilMarcoFolioReverso }}</h3>
              </div>
            </div>
            <div class="col pt-4 pb-4" *showForPermissions="['registro_civil_buscar_acto_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">A. <br />NACIMIENTO</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.registroCivilActoNacimiento }}</h3>
              </div>
            </div>
            <div class="col pt-md-4 pb-4" *showForPermissions="['registro_civil_buscar_acto_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">A. <br />DEFUNCIÓN</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.registroCivilActoDefuncion }}</h3>
              </div>
            </div>
            <div class="col pt-lg-4 pb-4" *showForPermissions="['registro_civil_buscar_acto_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">A. <br />MATRIMONIO</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.registroCivilActoMatrimonio }}</h3>
              </div>
            </div>
            <div class="col pt-lg-4 pb-4" *showForPermissions="['registro_civil_buscar_acto_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">A. <br />DIVORCIO</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.registroCivilActoDivorcio }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['sat_cambio_emision_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">CAMBIO <br />DE EMISIÓN</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.satCambioEmision }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['sat_constancia_situacion_fiscal_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">CONSTANCIA <br />SITUACIÓN FISCAL</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.satConstanciaSituacionFiscal }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['sat_opinion_cumplimiento_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">OPINIÓN DEL <br />CUMPLIMIENTO</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.satOpinionCumplimiento }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['sat_cedula_identificacion_fiscal_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">CÉDULA DE <br />IDENTIFICACIÓN FISCAL</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.satCedulaIdentificacionFiscal }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['sat_recuperacion_cfdi_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">RECUPERACIÓN <br />DE CFDI</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.satRecuperacionCfdi }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['sat_recuperacion_declaracion_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">RECUPERACIÓN <br />DE DECLARACIÓN</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.satRecuperacionDeclaracion }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['sat_cita_persona_fisica_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">CITA <br />PERSONA FÍSICA</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.satCitaPersonaFisica }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['sat_cita_persona_moral_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">CITA <br />PERSONA MORAL</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.satCitaPersonaMoral }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['sat_alta_rfc_primera_vez_con_contrasena_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">ALTA RFC PRIMERA <br />VEZ CON CONTRASEÑA</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.satAltaRfcPrimeraVezConContrasena }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['sat_alta_rfc_primera_vez_sin_contrasena_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">ALTA RFC PRIMERA <br />VEZ SIN CONTRASEÑA</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.satAltaRfcPrimeraVezSinContrasena }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['sat_contrasena_ciec_ine_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">CONTRASEÑA CIEC <br />CON INE</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.satContrasenaCiecIne }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['sat_restablecer_contrasena_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">RESTABLECER <br />CONTRASEÑA</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.satRestablecerContrasena }}</h3>
              </div>
            </div>
            <!-- <div class="col pb-4">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">ANTECEDENTE <br />NO PENAL</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.antecedenteNoPenal }}</h3>
              </div>
            </div> -->
            <!-- <div class="col pb-4">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">ANTECEDENTE <br />NO INHABILITACIÓN</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.antecedenteNoInhabilitacion }}</h3>
              </div>
            </div> -->
            <!-- <div class="col pb-4">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">ANTECEDENTE <br />FEDERAL</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.antecedenteFederal }}</h3>
              </div>
            </div> -->
            <div class="col pb-4" *showForPermissions="['imss_consultar_nss_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">CONSULTAR NSS</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.imssConsultarNss }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['imss_informacion_nss_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">INFORMACIÓN NSS</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.imssInformacionNss }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['imss_asignar_correo_nss_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">ASIGNAR <br />CORREO NSS</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.imssAsignarCorreoNss }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['imss_semanas_cotizadas_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">SEMANAS <br />COTIZADAS</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.imssSemanasCotizadas }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['imss_vigencia_derecho_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">VIGENCIA <br />DE DERECHO</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.imssVigenciaDerecho }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['imss_no_derechohabiente_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">NO DERECHOHABIENTE</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.imssNoDerechohabiente }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['renapo_curp_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">CURP</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.renapoCurp }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['renapo_correccion_curp_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">CORRECCIÓN <br />DE CURP</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.renapoCorreccionCurp }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['renapo_unificacion_curp_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">UNIFICACIÓN <br />DE CURP</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.renapoUnificacionCurp }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['renapo_certificacion_curp_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">CERTIFICACIÓN <br />DE CURP</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.renapoCertificacionCurp }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['issste_talon_pagos_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">TALON <br />DE PAGOS</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.isssteTalonPagos }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['issste_constancia_acreditacion_no_afiliacion_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">CONSTANCIA DE ACREDITACIÓN <br />DE NO AFILIACIÓN</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.isssteConstanciaAcreditacionNoAfiliacion }}</h3>
              </div>
            </div>
            <div class="col pb-4" *showForPermissions="['cfe_recibo_de_luz_access']">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center">RECIBO <br />DE LUZ</h2>
                <h3 class="text-center font-bold p-2 m-0">{{ totalActions.cfeReciboDeLuz }}</h3>
              </div>
            </div>
            <div class="col pb-4">
              <div class="mx-3 border">
                <h2 class="text-center border-bottom fs-6 py-2 m-0 h-50px d-flex flex-column justify-content-center text-info">TOTAL</h2>
                <h3 class="text-center font-bold p-2 m-0 text-info">{{ totalActions.total }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer border-0 py-1"></div>
      </div>
    }
  </section>
</backbone>
